// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var InvoiceTemplateController = function ($scope, DocumentTemplate, NumberSequence, SupportedHtmlTagsDescription, Features, salesEntitiesService) {
    salesEntitiesService.query({}, function (response) {
        $scope.salesEntities = response;
        if ($scope.salesEntities.length > 0) {
            $scope.settingsLoaded = true;
        }
        $scope.salesEntityDefault = $scope.salesEntities.find(function (el) {
            return el.IsDefault === true;
        });
        $scope.QRInvoiceType = $scope.salesEntityDefault.PdfSettings.QRInvoiceType;

        $scope.merchantPlaceholders = ['Merchant.CreditorId', 'Merchant.CompanyName', 'Merchant.AddressLine1',
            'Merchant.AddressLine2', 'Merchant.StreetAddress', 'Merchant.HouseNumber', 'Merchant.ZIP', 'Merchant.City',
            'Merchant.Country', 'Merchant.Phone', 'Merchant.Website', 'Merchant.IBAN', 'Merchant.BIC', 'Merchant.EmailAddress'];
        if ($scope.QRInvoiceType === "QRIBANQRReference")
            $scope.merchantPlaceholders.push('Merchant.QR-IBAN');
    });

    NumberSequence.getDocumentCounterSequences().then(function (data) { $scope.sequences = data; });
    DocumentTemplate.query({ documentType: 'Invoice' }, function (data) { $scope.template = data[0]; });

    $scope.features = Features.features;
    
    $scope.save = function () {
        if ($scope.template.Id && $scope.template.Id !== "000000000000000000000000")
            $scope.template.$update({ documentType: $scope.template.DocumentType, id: $scope.template.Id }, function () {
                $scope.notifySuccess();
            });
        else
            $scope.template.$save(function () {
                $scope.notifySuccess();
            });
    };

    $scope.generalPlaceholders = ['FirstName', 'LastName', 'CompanyName', 'EmailAddress', 'Customer.ExternalId',
        'ReferenceCode', 'DueDate', 'DebitorAccount', 'Customer.CustomFields.****', 'Contract.CustomFields.****',
        'Contract.ExternalId', 'PaymentText', 'Invoice.ReferenceCode', 'DocumentNumber', 'Balance', 'Currency'];

    $scope.directDebitPlaceholders = ['Pay.BIC', 'Pay.MaskedBIC', 'Pay.IBAN', 'Pay.MaskedIBAN', 'Pay.Holder',
        'Pay.BankCode', 'Pay.BankAccount', 'Pay.MandateReference'];

    $scope.creditCardPlaceholders = ['Pay.Last4', 'Pay.Holder', 'Pay.Expiry.Month', 'Pay.Expiry.Year', 'Pay.CardType'];
    
    $scope.blackLabelProviderPlaceholders = ['Pay.EmailAddress'];

    $scope.onAccountPlaceholders = ['Contract.IBAN'];

    SupportedHtmlTagsDescription.get().then(function (text) { $scope.popoverText = text; });
};  
InvoiceTemplateController.$inject = ['$scope', 'DocumentTemplate', 'NumberSequence', 'SupportedHtmlTagsDescription', 'Features', 'SalesEntities'];
